document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.LoftyLlama = window.LoftyLlama || {};
window.LoftyLlama.focusableSelector = 'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), details summary, [tabindex]:not([tabindex="-1"])';
window.LoftyLlama.trapFocus = function(container, event) {
  if (!container || event.key !== 'Tab') return;
  const focusable = Array.from(container.querySelectorAll(window.LoftyLlama.focusableSelector)).filter((el) => el.offsetParent !== null || el === document.activeElement);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
};

window.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const toggle = document.querySelector('[data-mobile-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');
  let mobileLastFocus = null;
  const closeMobile = () => {
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.removeAttribute('open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
    mobileLastFocus?.focus();
  };
  if (toggle && panel) {
    panel.setAttribute('aria-hidden', 'true');
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) { closeMobile(); return; }
      mobileLastFocus = toggle;
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('open', '');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-lock');
      panel.querySelector(window.LoftyLlama.focusableSelector)?.focus();
    });
    panel.addEventListener('keydown', (event) => window.LoftyLlama.trapFocus(panel, event));
  }

  function bindCardSizeForms(root = document) {
    root.querySelectorAll('[data-card-size-form]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      const input = form.querySelector('[data-card-variant-input]');
      const submit = form.querySelector('button[type="submit"]');
      form.querySelectorAll('[data-card-variant-id]').forEach((chip) => {
        chip.addEventListener('click', () => {
          form.querySelectorAll('[data-card-variant-id]').forEach((c) => c.classList.remove('is-selected'));
          chip.classList.add('is-selected');
          input.value = chip.dataset.cardVariantId;
          if (submit) { submit.disabled = false; submit.textContent = 'Add ' + chip.textContent.trim(); }
        });
      });
    });
  }
  bindCardSizeForms();
  document.addEventListener('loftyllama:cart-refreshed', () => bindCardSizeForms());

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterOverlay = document.querySelector('.filter-overlay');
  let filterLastFocus = null;
  const closeFilters = () => {
    if (!filterPanel) return;
    filterPanel.classList.remove('is-open');
    filterPanel.setAttribute('aria-hidden', 'true');
    filterToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('filters-open', 'drawer-lock');
    filterLastFocus?.focus();
  };
  const openFilters = () => {
    if (!filterPanel) return;
    filterLastFocus = document.activeElement;
    filterPanel.classList.add('is-open');
    filterPanel.setAttribute('aria-hidden', 'false');
    filterToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('filters-open', 'drawer-lock');
    filterPanel.querySelector(window.LoftyLlama.focusableSelector)?.focus();
  };
  if (filterPanel) filterPanel.setAttribute('aria-hidden', 'true');
  filterToggle?.addEventListener('click', () => filterPanel?.classList.contains('is-open') ? closeFilters() : openFilters());
  document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
  filterOverlay?.addEventListener('click', closeFilters);
  filterPanel?.addEventListener('keydown', (event) => window.LoftyLlama.trapFocus(filterPanel, event));

  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-results]');
    let controller;
    if (!input || !results) return;
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const clearResults = () => { results.innerHTML = ''; };
    const addGroup = (title, items, renderItem) => {
      if (!items || !items.length) return;
      const group = document.createElement('div');
      group.className = 'predictive-group';
      const strong = document.createElement('strong');
      strong.textContent = title;
      group.appendChild(strong);
      items.forEach((item) => group.appendChild(renderItem(item)));
      results.appendChild(group);
    };
    const linkItem = (href, label, image, small) => {
      const a = document.createElement('a');
      a.href = href;
      if (image) {
        const img = document.createElement('img');
        img.src = typeof image === 'string' ? image : (image.url || image.src || '');
        img.alt = '';
        img.loading = 'lazy';
        if (img.src) a.appendChild(img);
      }
      const span = document.createElement('span');
      span.textContent = label || '';
      a.appendChild(span);
      if (small) { const s = document.createElement('small'); s.textContent = small; a.appendChild(s); }
      return a;
    };
    const showFallback = () => {
      clearResults();
      addGroup('Popular searches', [
        ['Funny golf shirts', `${root}search?q=funny+golf+shirts`],
        ['Golf polos for men', `${root}search?q=golf+polos+for+men`],
        ['Golf gifts', `${root}search?q=golf+gifts`],
        ['Bachelor party golf shirts', `${root}search?q=bachelor+party+golf+shirts`],
        ['Golf trip shirts', `${root}search?q=golf+trip+shirts`],
        ['Size chart', `${root}pages/golf-polo-size-chart`]
      ], (item) => linkItem(item[1], item[0]));
      results.hidden = false;
    };
    input.addEventListener('focus', () => { if (!input.value.trim()) showFallback(); });
    input.addEventListener('input', async () => {
      const q = input.value.trim();
      if (q.length < 2) { showFallback(); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article,collection,query&resources[limit]=6`;
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' }});
        if (!response.ok) throw new Error('Predictive search failed');
        const data = await response.json();
        const resources = data.resources && data.resources.results ? data.resources.results : {};
        clearResults();
        addGroup('Products', resources.products, (item) => linkItem(item.url || '#', item.title, item.image, item.price));
        addGroup('Collections', resources.collections, (item) => linkItem(item.url || '#', item.title));
        addGroup('Guides and pages', resources.pages, (item) => linkItem(item.url || '#', item.title));
        addGroup('Articles', resources.articles, (item) => linkItem(item.url || '#', item.title));
        addGroup('Search ideas', resources.queries, (item) => linkItem(`${root}search?q=${encodeURIComponent(item.text || item.query || q)}`, item.text || item.query || q));
        if (!results.children.length) {
          const empty = document.createElement('span'); empty.textContent = 'No quick matches. Press enter to search.'; results.appendChild(empty);
        }
        results.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') { clearResults(); const span = document.createElement('span'); span.textContent = 'Search suggestions are unavailable.'; results.appendChild(span); results.hidden = false; }
      }
    });
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape') results.hidden = true; });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) results.hidden = true; });
  });

  document.querySelectorAll('product-recommendations').forEach(async (el) => {
    if (!el.dataset.url) return;
    try {
      const response = await fetch(el.dataset.url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('product-recommendations');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (error) {}
  });

  document.querySelectorAll('[data-guide-toc-toggle]').forEach((button) => {
    const toc = button.closest('.guide-toc');
    if (!toc) return;
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      const open = toc.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });

  document.querySelectorAll('[data-guide-section]').forEach((section) => {
    const body = section.querySelector('.guide-body');
    const nav = section.querySelector('[data-guide-toc]');
    if (!body || !nav) return;
    const headings = body.querySelectorAll('h2, h3');
    if (!headings.length) return;
    nav.innerHTML = '';
    const used = new Set();
    headings.forEach((heading) => {
      let base = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      let id = base || 'section';
      let i = 2;
      while (used.has(id)) id = `${base}-${i++}`;
      used.add(id);
      heading.id = id;
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = heading.textContent;
      if (heading.tagName === 'H3') a.classList.add('toc-child');
      nav.appendChild(a);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMobile();
    closeFilters();
  });
});
